import i18next, { InitOptions } from "i18next";
import {
    cart,
    confirmation,
    control,
    customerDetails,
    glossary,
    home,
    summary,
    address,
    common,
    validation,
    footer,
    header,
    portin,
    countdown
} from "./en/translate";
//import { cart, confirmation, control, customerDetails, glossary, home, summary } from "./el/translate";
import {
    ELcart,
    ELconfirmation,
    ELcontrol,
    ELcustomerDetails,
    ELglossary,
    ELhome,
    ELsummary,
    ELaddress,
    ELcommon,
    ELvalidation,
    ELfooter,
    ELheader,
    ELportin,
    ELcountdown
} from "./el/translate";
import { centsToPrice } from "src/itsf/utils/priceUtils";

export const resources = {
    en: {
        cart,
        confirmation,
        control,
        customerDetails,
        glossary,
        home,
        summary,
        address,
        validation,
        common,
        footer,
        header,
        portin,
        countdown
    },
    el: {
        cart: ELcart,
        confirmation: ELconfirmation,
        control: ELcontrol,
        customerDetails: ELcustomerDetails,
        glossary: ELglossary,
        home: ELhome,
        summary: ELsummary,
        address: ELaddress,
        validation: ELvalidation,
        common: ELcommon,
        footer: ELfooter,
        header: ELheader,
        portin: ELportin,
        countdown: ELcountdown
    },
} as const;

const i18nOptions: InitOptions = {
    fallbackLng: "en",
    fallbackNS: "common",
    lng: "en",
    ns: [
        "cart",
        "glossary",
        "confirmation",
        "customerDetails",
        "home",
        "summary",
        "common",
        "address",
        "validation",
        "footer",
        "header",
        "portin",
        "countdown",
    ],
    resources,
    interpolation: {
        format: (value, format) => {
            if (format === "priceFormat") {
                return `€${centsToPrice(value)}`;
            }

            return value ? value.toString() : "";
        },
        escapeValue: false,
    },
    react: {
        useSuspense: false,
    },
};

const i18n = i18next.createInstance();

//i18n.init(i18nOptions);

i18n.init(
    {
        ...i18nOptions,
    },
    () => {
        var urlPath = window.location.pathname;
        var lang = urlPath.split("/")[1];
        if (lang == null) {
            lang = "en";
        }
        i18n.changeLanguage(lang);
        return;
    }
);

export { i18n };
